/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetIssuanceProfileRequestBody,
  SetIssuanceProfileRequestBody$Outbound,
  SetIssuanceProfileRequestBody$outboundSchema,
} from "../components/setissuanceprofilerequestbody.js";

export type SetIssuanceProfileSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type SetIssuanceProfileRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  setIssuanceProfileRequestBody: SetIssuanceProfileRequestBody;
};

/** @internal */
export type SetIssuanceProfileSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const SetIssuanceProfileSecurity$outboundSchema: z.ZodMiniType<
  SetIssuanceProfileSecurity$Outbound,
  SetIssuanceProfileSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function setIssuanceProfileSecurityToJSON(
  setIssuanceProfileSecurity: SetIssuanceProfileSecurity,
): string {
  return JSON.stringify(
    SetIssuanceProfileSecurity$outboundSchema.parse(setIssuanceProfileSecurity),
  );
}

/** @internal */
export type SetIssuanceProfileRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  SetIssuanceProfileRequestBody: SetIssuanceProfileRequestBody$Outbound;
};

/** @internal */
export const SetIssuanceProfileRequest$outboundSchema: z.ZodMiniType<
  SetIssuanceProfileRequest$Outbound,
  SetIssuanceProfileRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    setIssuanceProfileRequestBody: SetIssuanceProfileRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      setIssuanceProfileRequestBody: "SetIssuanceProfileRequestBody",
    });
  }),
);

export function setIssuanceProfileRequestToJSON(
  setIssuanceProfileRequest: SetIssuanceProfileRequest,
): string {
  return JSON.stringify(
    SetIssuanceProfileRequest$outboundSchema.parse(setIssuanceProfileRequest),
  );
}
